/**
 * Function to observe URL changes (replaceState, pushState)
 * @returns Cleanup function
 */
export const createHistoryObserver = () => {
  const originalPushState = window.history.pushState;
  const originalReplaceState = window.history.replaceState;

  const handleChange = () => window.dispatchEvent(new Event('paramChange'));

  window.history.pushState = function (...args) {
    originalPushState.apply(this, args);
    handleChange();
  };

  window.history.replaceState = function (...args) {
    originalReplaceState.apply(this, args);
    handleChange();
  };

  // Return cleanup function
  return () => {
    window.history.pushState = originalPushState;
    window.history.replaceState = originalReplaceState;
  };
};
